import { formatMoney } from './string/formatMoney';

export const DEFAULT_MATCH_COMMISSION = 0.1;

export function calculateMatchPayoutCents(
  stakeCents: number,
  commission = DEFAULT_MATCH_COMMISSION,
): number {
  if (!Number.isInteger(stakeCents) || stakeCents < 0) {
    throw new Error(`Invalid stake cents for payout: ${String(stakeCents)}`);
  }

  return Math.floor(stakeCents * 2 * (1 - commission));
}

export function formatMatchPayoutLabel(stakeCents: number): string {
  const payoutCents = calculateMatchPayoutCents(stakeCents);

  return formatMoney(payoutCents, {
    maxDigits: payoutCents % 100 === 0 ? 0 : 2,
  });
}
